module.exports = __webpack_public_path__ + "static/media/poster6.25443392.png";